import { toRefs as C, resolveComponent as c, openBlock as l, createBlock as P, withCtx as u, renderSlot as d, createVNode as s, createTextVNode as m, createElementBlock as b, Fragment as v, renderList as y, toDisplayString as k } from "vue";
import I from "./design-system.es84.js";
/* empty css                    */
import L from "./design-system.es128.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import x from "./design-system.es62.js";
import D from "./design-system.es59.js";
/* empty css                    */
/* empty css                    */
import N from "./design-system.es117.js";
import _ from "./design-system.es116.js";
const S = {
  name: "DsPager",
  components: { PagerButton: I, IconButton: D, Inline: x },
  props: {
    pageCount: {
      type: Number,
      required: !0
    },
    currentPage: {
      type: Number,
      required: !0
    },
    size: {
      type: String,
      default: "large",
      validator: (r) => ["extra-small", "small", "medium", "large"].includes(r)
    }
  },
  emits: ["change"],
  setup(r) {
    const t = _(), { pageCount: e, currentPage: a, size: g } = C(r), f = N({ pageCount: e, currentPage: a, size: g }), o = t.t("pagination.next"), i = t.t("pagination.previous");
    return {
      pager: f,
      nextLabel: o,
      previousLabel: i
    };
  }
};
function q(r, t, e, a, g, f) {
  const o = c("IconButton"), i = c("PagerButton"), p = c("Inline");
  return l(), P(p, {
    as: "nav",
    space: "spacing-050"
  }, {
    default: u(() => [
      d(r.$slots, "previous", {
        disabled: e.currentPage === 1
      }, () => [
        s(o, {
          name: "chevron-left",
          disabled: e.currentPage === 1,
          "aria-label": a.previousLabel,
          onClick: t[0] || (t[0] = (n) => r.$emit("change", e.currentPage - 1))
        }, null, 8, ["disabled", "aria-label"])
      ]),
      t[2] || (t[2] = m()),
      s(p, { space: "spacing-025" }, {
        default: u(() => [
          (l(!0), b(v, null, y(a.pager, (n, B) => (l(), b(v, {
            key: `${n}-${B}`
          }, [
            n === "…" ? (l(), P(i, {
              key: 0,
              disabled: ""
            }, {
              default: u(() => [
                m(k(n), 1)
              ]),
              _: 2
            }, 1024)) : d(r.$slots, "page", {
              key: 1,
              page: n,
              current: n === e.currentPage
            }, () => [
              s(i, {
                current: n === e.currentPage,
                "aria-current": n === e.currentPage ? "true" : null,
                onClick: (z) => r.$emit("change", n)
              }, {
                default: u(() => [
                  m(k(n), 1)
                ]),
                _: 2
              }, 1032, ["current", "aria-current", "onClick"])
            ])
          ], 64))), 128))
        ]),
        _: 3
      }),
      t[3] || (t[3] = m()),
      d(r.$slots, "next", {
        disabled: e.currentPage === e.pageCount
      }, () => [
        s(o, {
          name: "chevron-right",
          disabled: e.currentPage === e.pageCount,
          "aria-label": a.nextLabel,
          onClick: t[1] || (t[1] = (n) => r.$emit("change", e.currentPage + 1))
        }, null, 8, ["disabled", "aria-label"])
      ])
    ]),
    _: 3
  });
}
const M = /* @__PURE__ */ L(S, [["render", q]]);
export {
  M as default
};
//# sourceMappingURL=design-system.es83.js.map
